"use strict";

import {
     commonConstants,
     participantConstants,
     responseCodes,
} from "../_constants";

export const INITIAL_PARTICIPANT_STATE = {
     application : [],
     recodeList : [],
     areaList : [],
     dealerList:[],
     jobRoleList:[],
};

export function participants(state = INITIAL_PARTICIPANT_STATE, action) {
    switch (action.type) {
     case participantConstants.PARTICIPANT_GET_APPLICATION_COMPLETE:
          return {
               ...state,
               application: action.payload,
          };
     case participantConstants.PARTICIPANT_GET_PARTICIPANT_SUMMARY_COMPLETE:
     return {
          ...state,
          recodeList: action.payload,
     };
     case participantConstants.PARTICIPANT_GET_AREAS_COMPLETE:
          return {
               ...state,
               areaList: action.payload,
          };
     case participantConstants.PARTICIPANT_GET_DEALERS_COMPLETE:
          return {
               ...state,
               dealerList: action.payload,
          };
     case participantConstants.PARTICIPANT_GET_JOB_ROLES_COMPLETE:
          return {
               ...state,
               jobRoleList: action.payload,
          };
     case participantConstants.PARTICIPANT_GET_TLC_CUSTOMERS_COMPLETE:
          return {
               ...state,
               tlcCustomerList: action.payload,
          };

     case participantConstants.PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_COMPLETE:
          return {
               ...state,
               campaignMeasurement: action.payload,
          };
    }
    return state;
}